import React, { FC, forwardRef } from 'react';
import { default as MuiTooltip } from '@material-ui/core/Tooltip';
import { TooltipProps } from './types';

const Tooltip: FC<TooltipProps> = forwardRef(({
  children,
  title,
  arrow,
  placement,
  enterDelay,
  enterNextDelay,
  ...restProps
}, ref) => {
  return (
    <MuiTooltip
      title={title}
      arrow={arrow}
      placement={placement}
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      ref={ref}
      {...restProps}
    >
      {children}
    </MuiTooltip>
  );
});

export default Tooltip;
